import { useParams } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import DrugScreenForm from '@/forms/DrugScreenForm';
import useAPI from '@/hooks/useAPI';
import DrugScreenRepository from '@/repositories/DrugScreenRepository';
import Alert from '@/ui/components/Alert';
import Container from '@/ui/components/Container';
import Spinner from '@/ui/components/Spinner';

const PersonDrugScreen = () => {
  const { drugScreenId } = useParams();

  const drugScreenRepository = DrugScreenRepository();

  const { data, isError, isLoading } = useAPI({
    queryKey: ['getPersonDrugScreen', drugScreenId],
    queryFn: async () => {
      return await drugScreenRepository.getDrugScreen(drugScreenId);
    },
    enabled: !!drugScreenId
  });

  if (!drugScreenId) return <Alert level="error">No Drug Screen ID provided</Alert>;

  if (isError) return <Alert level="error">Failed to get drug screen data</Alert>;

  if (isLoading) return <Spinner />;

  if (data?.data?.id)
    return (
      <Container type="page">
        <PageHeader headingText="Drug Screen Results" />
        {!data.data.is_mutable && (
          <Alert level="warn">This drug screen is no longer editable.</Alert>
        )}
        <DrugScreenForm appointmentId={data.data.appointment?.id} drugScreen={data.data} />
      </Container>
    );
};

export default PersonDrugScreen;
